    import React from 'react';
    import { useSession } from '../Session';

const CircleBar = ({size, percent, value, total, theme, track, label, className, colors}) => {
    const {showDarkMode} = useSession();

    let _percent, inner, timer;

    if (value !== undefined && total !== undefined) {
        if (total === 0) {
            _percent = 0;
        } else {
            _percent = Math.round((value / total) * 100);
        }
        inner = value;
        timer = 'dynamic';
    } else {
        _percent = percent ?? 0;
        inner = `${Math.round(percent)}%`;
        timer = 'static'
    }

    // const [radius, setRadius] = useState(0);
    const themes = {
        primary: 'stroke-brand fill-brand',
        danger: 'stroke-red-600 fill-red-600',
        secondary: 'stroke-gray-500 fill-gray-500',
        success: 'stroke-green-500 fill-green-500',
        light: 'stroke-light fill-light',
    };
    const themeClasses = colors ?? themes[theme] ?? themes['primary'];

    const strokeWidth = Math.round(size/8);

    // SVG centers the stroke width on the radius, subtract out so circle fits in square
    const radius = (size - strokeWidth) / 2;
    // Arc length at 100% coverage is the circle circumference
    const dashArray = radius * Math.PI * 2;
    // Scale 100% coverage overlay with the actual percent
    const dashOffset = dashArray - dashArray * _percent / 100;

    const height = label ? Math.ceil(size * 1.5) : size;

    return <svg className={className} width={size} height={height} viewBox={`0 0 ${size} ${size * 1.4}`} overflow="visible">

        <circle style={{
                strokeWidth: `${strokeWidth}px`,
                fill: 'transparent',
            }}
            className={track ?? 'stroke-gray-200 dark:stroke-gray-700'}
            cx={size / 2}
            cy={size / 2}
            r={radius}
        />

        <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={`${strokeWidth}px`}
            // Start progress marker at 12 O'Clock
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            style={{
                strokeDasharray: dashArray,
                strokeDashoffset: dashOffset,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                fill: 'transparent',
            }}
            className={themeClasses}
        >
            <animate attributeName="stroke-dashoffset"
                    values={dashArray+';'+dashOffset}
                    dur={(timer === 'dynamic' ? Math.round(_percent * 10) : '750')+"ms"}
                    // calcMode="spline"
            />
        </circle>

        <text x="50%"
            y={size / 2}
            dy=".3em"
            fontSize={`${Math.round(size / 3.5)}px`}
            textAnchor="middle"
            className={themeClasses}
        >
            {inner}
        </text>

        {label && <text x="50%"
            y={size * 1.3}
            // dy=".1em"
            fontSize={`${Math.round(size / 4)}px`}
            // textLength={label.length < 7 ? null : size}
            // lengthAdjust={label.length < 7 ? null : 'spacingAndGlyphs'}
            textAnchor="middle"
            className={showDarkMode ? 'text-muted' : themeClasses}
        >
            {label}
        </text>}

    </svg>
}

export default CircleBar;
